import React, { FC, ReactElement, useContext, useMemo } from 'react';
import { Box, ResponsiveContext, Text } from 'grommet';
import { DashboardVideo } from '@/components/home/DashboardVideo';
import { ScanTarget } from '@/components/home/ScanTarget';
import { Subheading } from '@/components/Subheading';

export const GrowYourBusiness: FC = (): ReactElement => {
  const size = useContext(ResponsiveContext);
  const isSmall = useMemo(() => size === `small`, [size]);
  return (
    <Box
      direction="row-responsive"
      justify="between"
      align="center"
      gap="large"
    >
      <Box width={{ max: `large` }}>
        <Subheading margin={{ top: `small` }} textAlign="center">
          EASY TO USE & FREE TO TRY (NO CREDIT CARD REQUIRED)
        </Subheading>
        <Text
          size={isSmall ? `3xl` : `4xl`}
          style={{ zIndex: 1 }}
          margin={{ top: `medium` }}
          textAlign="center"
          wordBreak="break-word"
        >
          Is Your Data Safe?
          <br />
          <strong>View Critical Risks in Under 30 Seconds.</strong>
        </Text>
        <ScanTarget
          buttonProps={{ style: { zIndex: 1 } }}
          containerProps={{
            style: { zIndex: 1 },
            margin: { top: `medium` },
            animation: {
              type: `fadeIn`,
              duration: 1000,
              delay: 0,
              size: `medium`,
            },
          }}
        />
      </Box>
      <DashboardVideo />
    </Box>
  );
};
